import {DistanceUnit, DEFAULT_DISTANCE_UNIT} from "../../constans/statuses/distanceUnits";

const NAUTICAL_MILE_TO_KM = 1.852;
const KM_TO_NAUTICAL_MILE = 1 / 1.852;

/**
 * Конвертирует расстояние из километров в единицы измерения пользователя
 *
 * @param distanceInKm Расстояние в километрах
 * @param userDistanceUnit Единица измерения пользователя (DistanceUnit)
 * @returns Расстояние в единицах измерения пользователя (целое число)
 */
export const convertFromKm = (distanceInKm: number, userDistanceUnit: DistanceUnit = DEFAULT_DISTANCE_UNIT): number => {
  if (userDistanceUnit === DistanceUnit.NAUTICAL_MILE) {
    return Math.round(distanceInKm * KM_TO_NAUTICAL_MILE);
  }

  return Math.round(distanceInKm);
};

/**
 * Конвертирует расстояние из единиц измерения пользователя в километры
 *
 * @param distance Расстояние в единицах измерения пользователя
 * @param userDistanceUnit Единица измерения пользователя (DistanceUnit)
 * @returns Расстояние в километрах (целое число)
 */
export const convertToKm = (distance: number, userDistanceUnit: DistanceUnit = DEFAULT_DISTANCE_UNIT): number => {
  if (userDistanceUnit === DistanceUnit.NAUTICAL_MILE) {
    return Math.round(distance * NAUTICAL_MILE_TO_KM);
  }

  return Math.round(distance);
};

/**
 * Получает единицу измерения для отображения
 *
 * @param userDistanceUnit Единица измерения пользователя (DistanceUnit)
 * @returns Строка единицы измерения (например, "nm" или "km")
 */
export const getUnitLabel = (userDistanceUnit: DistanceUnit = DEFAULT_DISTANCE_UNIT): string => {
  if (userDistanceUnit === DistanceUnit.NAUTICAL_MILE) {
    return 'nm';
  }

  return 'km';
};

